module.exports = __webpack_public_path__ + "img/01.5afb0550.jpg";